// @flow
import { useMemo } from 'react';
import moment from 'moment-timezone';
import prop from 'ramda/es/prop';
import values from 'ramda/es/values';
import pick from 'ramda/es/pick';
import pipe from 'ramda/es/pipe';
import map from 'ramda/es/map';

import { type StatementType, type StatementFileType } from './StatementsData';


export default function useStatementInfoViewData(statement: ?StatementType, timezone: string) {
  return useMemo(() => {
    const {
      number,
      created_at: createdAt,
      subject,
      content,
      school,
      recipients,
      attached_files: files,
    } = statement || {};

    const numberView: string = typeof number === 'number' ? `№ ${String(number)} ` : '';
    const mCreatedAt = moment(createdAt);
    const createdAtView: string = (mCreatedAt.isValid()
      ? `от ${mCreatedAt.tz(timezone).format('DD.MM.YYYY HH:mm')}`
      : '');
    const schoolTitleView: string = prop('title', school);
    const whomView: Array<{ id: number, title: string }> = recipients ? pipe(
      values,
      map(pick(['id', 'title']))
    )(recipients) : [];
    const filesView: Array<StatementFileType> = values(files);

    return [
      numberView,
      createdAtView,
      schoolTitleView,
      whomView,
      subject,
      content,
      filesView,
    ];
  }, [statement, timezone]);
}
